import {Component, Vue, Watch} from "vue-property-decorator";
import {cloneDeep} from "lodash";
import { notifyError, notifySuccess } from "@/utils/notify-helper";

// Экспериментальный интерфейс
export interface IBaseFilter<T> {
  doActionExport: (filter: T) => Promise<any>;
}

@Component
export default class BaseFilter<T extends object> extends Vue /* implements IBaseFilter<T> */ {
  filter: T;
  sendFilter: T = this.defaultFilter();

  moreLoading = false;
  flag = null;

  constructor() {
    super()
    this.filter = this.currentFilter();
  }

  defaultFilter():T {
    return Object.create({})
  }

  storageItemName():string {
    return this.$options.name || '';
  };

  currentFilter(): T {
    if (sessionStorage.getItem(this.storageItemName()) && sessionStorage.getItem(this.storageItemName()) !== 'undefined'){
      return JSON.parse(sessionStorage.getItem(this.storageItemName()) || '')
    }
    return this.defaultFilter();
  }

  clearEmpty(){
    let filter: any = this.filter;
    let defaultFilter: any = this.defaultFilter();
    for (let field in filter){
      if (filter[field] === ''){
        this.$set(this.sendFilter, field, defaultFilter[field]);
        this.$set(this.filter, field, defaultFilter[field]);
      }
    }
  }

  filtered(): void {
    this.clearEmpty();
    this.sendFilter = cloneDeep(this.filter)
    this.onFilteredAction();
  }

  onFilteredAction(flag = null) {

  }

  unsetFilter(field: string): void {
    let defaultFilter: any = this.defaultFilter();
    this.$set(this.filter, field, defaultFilter[field]);
    // this.filtered()
    this.flag = null
  }

  clear(): void {
    this.filter = this.defaultFilter()
    // this.filtered()
    this.flag = null
  }

  checkChangeFilter(variable: string): boolean {
    function getValue(obj: any): string | undefined {
      if (typeof obj == 'string') return obj;
      if (typeof obj == 'undefined') return obj;
      if (obj == null) return obj;
      return obj.toString()
    }

    let defaultFilter: any = this.defaultFilter();
    let filter: any = this.sendFilter;

    return getValue(filter[variable]) === getValue(defaultFilter[variable])
  }

  @Watch('sendFilter',{ immediate: true, deep: true })
  onSendFilterChanged(val: T) {
    sessionStorage.setItem(this.storageItemName(), JSON.stringify(val))
  }

  get filterChangeCount(): number {
    let obj1: any = this.filter;
    let obj2: any = this.defaultFilter();
    let count = 0;
    for (let p in obj1) {
      if (Array.isArray(obj1[p])) {
        if (obj1[p].length) {
          count++;
        }
      } else if (obj1[p] !== obj2[p]){
        count++;
      }
    }
    return count;
  };

  get isFilterChange(): boolean {
    let currFilter: any = this.filter;
    let defaultFilter: any = this.defaultFilter();
    let result = false;
    for (let i in defaultFilter) {

      if (Array.isArray(currFilter[i])) {
        if (currFilter[i].length) {
          result = true;
        }
      }
      else if (typeof currFilter[i] === "number") {
        if (currFilter[i] !== defaultFilter[i]) {
          result = true;
        }
      }
      else if (currFilter[i]) {
        if (currFilter[i] !== defaultFilter[i]) {
          result = true;
        }
      }

    }
    return result;
  }

  async doActionExport(filter: T): Promise<any> {

  };

  async newExport() {
    let tempFilter = cloneDeep(this.filter);
    if ((<any>this.filter)['flag']) {
      (<any>tempFilter)['flag'] = null;
    }
    try {
      let resp = await this.doActionExport(tempFilter);
      if (resp.data.status === 'Success') {
        notifySuccess(this.$t('dialog.export').toString());
      } else {
        notifyError();
      }
    } catch(err) {
      notifyError(err);
    }
  }

  scrollFunction() {
    if (!this.flag) return;
    let table = <HTMLElement>document.querySelector('.md-table-content');
    if (!table) return;
    let card = <HTMLElement>table.closest('.md-card-content');

    let offsetTop = card.offsetTop + table.offsetTop;
    let bottomOfTable = document.documentElement.scrollTop + window.innerHeight >= (offsetTop + table.offsetHeight);

    if (bottomOfTable && !this.moreLoading) {
      this.moreLoading = true;
      this.onFilteredAction(this.flag);
    }
  }

  scroll() {
    window.addEventListener('scroll', this.scrollFunction)
  }

  unscroll() {
    window.removeEventListener('scroll', this.scrollFunction)
  }

  beforeDestroy(): void {
    this.unscroll()
  }
}
